import IconButton from "@mui/material/IconButton";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { ArrowSquareLeft } from "@phosphor-icons/react/ArrowSquareLeft";
import { ArrowSquareRight } from "@phosphor-icons/react/ArrowSquareRight";

export const FeatureChange = ({
	handleFeatureChange,
	currentIndex,
	featuresCount,
}) => {
	const isMultipleFeatures = featuresCount > 1;
	if (!isMultipleFeatures) return null;
	return (
		<Stack
			p={2}
			direction="row"
			alignItems="center"
			justifyContent={"space-between"}>
			<IconButton
				disabled={currentIndex === 0}
				onClick={() => {
					handleFeatureChange(-1);
				}}>
				<ArrowSquareLeft />
			</IconButton>
			<Typography
				color="text.secondary"
				variant="subtitle2">
				{currentIndex + 1}/{featuresCount} MULTIPLE FEATURES SELECTED
			</Typography>
			<IconButton
				disabled={currentIndex === featuresCount - 1}
				onClick={() => {
					handleFeatureChange(1);
				}}>
				<ArrowSquareRight />
			</IconButton>
		</Stack>
	);
};
